import { setContext } from '@apollo/client/link/context';
import { formatISO } from 'date-fns';
import { getStoreLocalTime } from 'features/store/utils';

const USER_DATETIME_HEADER = 'x-user-datetime';

// add operations that use the real time here otherwise store time is used
const USE_CLIENT_TIME_OPERATIONS = ['GetRestaurant'];

export const withDateTimeHeaders = setContext(({ operationName }, previousContext) => {
  const storeTime = getStoreLocalTime();
  const prevHeaders = typeof previousContext.headers === 'object' ? previousContext.headers : null;

  return {
    ...previousContext,
    headers: {
      ...prevHeaders,
      [USER_DATETIME_HEADER]:
        storeTime && !USE_CLIENT_TIME_OPERATIONS.includes(operationName || '')
          ? storeTime
          : formatISO(new Date()),
    },
  };
});
